import type { Module } from 'vuex'
import type { RootState } from '@/store'
import type { DeviceModelsState } from './types'
import { DEVICE_MODELS_ACTIONS, DEVICE_MODELS_GETTERS } from './types'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state from './state'

const deviceModels: Module<DeviceModelsState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export { DEVICE_MODELS_ACTIONS, DEVICE_MODELS_GETTERS }
export type { DeviceModelsState }
export default deviceModels
